import React, { useState } from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
} from "@chakra-ui/react";

export default function CTextarea({
  label,
  labelProps,
  touched,
  errors,
  rows = 3,
  ...inputProps
}) {
  return (
    <FormControl isInvalid={errors && touched}>
      <FormLabel fontWeight="semibold" {...labelProps}>
        {label}
      </FormLabel>
      <Textarea
        rows={rows}
        bg="white"
        borderRadius="lg"
        focusBorderColor="primary.main"
        {...inputProps}
      />
      {errors && touched && <FormErrorMessage>{errors}</FormErrorMessage>}
    </FormControl>
  );
}
